module.exports = __webpack_public_path__ + "static/fonts/Robotothinitalic.d48c130.woff";